import { render, staticRenderFns } from "./editCompetencyGroup.vue?vue&type=template&id=af8b5488&"
import script from "./editCompetencyGroup.vue?vue&type=script&lang=js&"
export * from "./editCompetencyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports